/* This component shows the search results on the Explore page */

import React, { Component } from 'react';
import { Form, Button, ProgressBar, Row, Col, Container, ButtonGroup, OverlayTrigger, Tooltip} from 'react-bootstrap';
import { SearchResult } from "./SearchResult";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedo } from '@fortawesome/free-solid-svg-icons';
import Pluralize from 'pluralize';
import { redirectToTarget } from '../modules/utils';
import { layerConfig } from '../config/layerConfig';

class SearchResults extends Component {
  constructor(props) {
    super(props);
    this.state = {
      perPage: 5
    }

  }

  componentDidMount(){
      console.log("search results mounted")
  }

  componentWillUnmount() {
      // console.log("search results will unmount")
  }

  changeMode(evt){
    try{
      let mode = evt.target.dataset.mode;
      if (this.state.mode === mode){
        this.setState({mode: null})
      } else {
        this.setState({mode})
      }
    } catch(err){
      console.error("There was a problem changing the add/remove mdoe", evt.err)
    }
  }

  render() {

    const extentChanged = this.props.extentChanged;
    const searchPending = this.props.searchPending;
    let searchMessages = [];
    if (this.props.searchMessages) {
      searchMessages = this.props.searchMessages.map((message, id) =>
        <li key={id}>{message}</li>
      );
    }
    let progress = null;
    if (this.props.nearbyBuffers && this.props.nearbyBuffers.length > 0) {
      progress = (this.props.queryResponseCount / this.props.nearbyBuffers.length) * 100;
    }

    // pagination
    let showPagination = (this.props.features.length > this.state.perPage-1);
    let offset = (this.props.paginationCurrentPage -1) * this.state.perPage;
    let endIdx = offset + this.state.perPage;
    let features = [];
    if (showPagination) {
      features = this.props.features.slice(offset, endIdx)
    } else {
      features = this.props.features;
    }

    let areaMessage = "Crown Estate areas selected:"
    // if (this.props.useOverlayLayer) {
    //   areaMessage = "Crown Estate assets selected in map view and within Identified Overlap layer."
    // }

    let ferDriver;
    if (this.props.fer !== 'any'){
      ferDriver = layerConfig().internal.clcLayer.ferFields.find(o => o.name === this.props.fer).label;
    }

    return (
      
      <Form id="searchResults" onSubmit={this.props.handleSearchSubmit}>
        <p className="instructionalText mt-4">Refine your selection by adjusting <strong>Filter Criteria</strong>, or <strong>Add</strong> and <strong>Remove</strong> areas individually on the map. <strong>Create Report</strong> to open a new page containing selection and visible <strong>Map Layers</strong>.</p>
        <hr/>
        <h2>Filter Criteria</h2>

        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id='tooltip-right'>
              Change the selection criteria
            </Tooltip>
          }
        >
          <Button
            id="btnRedoSearch"
            className="pl-0 resultsButton"
            variant="turquoiseText"
            onClick={() => this.props.setSidebarMode("search")}
            disabled={searchPending}
          >
              <svg className="mr-1 resultsIcon"width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
               <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6456 1.38252C11.8684 0.605732 10.6106 0.605893 9.83365 1.383L9.20023 2.01942L2.50133 8.71695H2.46055L2.41477 8.80853C2.41035 8.81347 2.40452 8.82028 2.39837 8.82849L2.35838 8.88182V8.8943C2.35484 8.9012 2.35232 8.90701 2.35078 8.91076L2.34389 8.92453L2.3414 8.93449C2.33901 8.93906 2.33672 8.94387 2.33457 8.9489L2.32114 8.97577V8.98771L0.833116 13.4642C0.766978 13.6628 0.814716 13.8844 0.969535 14.0347L0.970449 14.0355C1.07587 14.1366 1.21691 14.1943 1.3638 14.1943C1.42401 14.1943 1.48109 14.1856 1.53724 14.1683L6.0211 12.6724C6.03296 12.6695 6.04603 12.665 6.05966 12.6585H6.0633L6.10553 12.6374C6.11841 12.6309 6.14388 12.6175 6.1695 12.597C6.1892 12.5835 6.20501 12.5693 6.21431 12.5603C6.21574 12.5591 6.21723 12.5579 6.21875 12.5565C6.22021 12.5552 6.2217 12.5539 6.22322 12.5525C6.23321 12.5442 6.24564 12.5325 6.25773 12.5169L13.6172 5.15578C14.3943 4.37854 14.3943 3.12013 13.6172 2.34288L12.6456 1.38252ZM13.9918 3.57789C14.0409 4.09093 13.8689 4.62107 13.4757 5.01433L6.102 12.3897C6.09994 12.3959 6.09492 12.3991 6.0912 12.4015C6.08974 12.4024 6.08848 12.4032 6.08768 12.404C6.08768 12.4058 6.08659 12.4065 6.08507 12.4074C6.08414 12.408 6.08305 12.4086 6.08195 12.4097C6.07336 12.4183 6.0619 12.4298 6.05044 12.4355C6.04185 12.4441 6.02752 12.4527 6.01606 12.4585C6.01463 12.4585 6.0132 12.4592 6.01177 12.4599C6.01033 12.4606 6.0089 12.4613 6.00747 12.4613C5.99888 12.467 5.98742 12.4728 5.97596 12.4756C5.97431 12.4773 5.97361 12.478 5.97277 12.4783C5.97215 12.4785 5.97145 12.4785 5.97023 12.4785L1.47838 13.9771C1.44114 13.9885 1.4039 13.9943 1.36379 13.9943C1.26926 13.9943 1.17759 13.957 1.10883 13.8911C1.05938 13.8431 1.02691 13.7833 1.01256 13.7191C1.02691 13.7833 1.05938 13.8431 1.10885 13.8912C1.1776 13.9571 1.26927 13.9943 1.3638 13.9943C1.40391 13.9943 1.44115 13.9886 1.47839 13.9771L5.97024 12.4786C5.971 12.4786 5.97156 12.4786 5.97203 12.4785C5.9723 12.4785 5.97255 12.4784 5.97278 12.4783C5.97362 12.478 5.97432 12.4773 5.97597 12.4757C5.98743 12.4728 5.99889 12.4671 6.00748 12.4614C6.00891 12.4614 6.01034 12.4606 6.01178 12.4599C6.01321 12.4592 6.01464 12.4585 6.01607 12.4585C6.02753 12.4528 6.04186 12.4442 6.05045 12.4356C6.06191 12.4298 6.07337 12.4184 6.08196 12.4098C6.08306 12.4087 6.08415 12.408 6.08508 12.4074C6.0866 12.4065 6.08769 12.4058 6.08769 12.4041C6.0885 12.4033 6.08975 12.4024 6.09121 12.4015C6.09493 12.3991 6.09995 12.3959 6.10202 12.3897L13.4757 5.01438C13.8689 4.62111 14.0409 4.09095 13.9918 3.57789ZM12.8353 3.14381C13.1705 3.48415 13.1703 4.03703 12.8301 4.37726L12.5924 4.61869L10.3868 2.41266L10.6293 2.17011C10.9694 1.8299 11.5217 1.8299 11.8619 2.17011L12.8353 3.14381ZM10.104 2.41264L10.4879 2.0287C10.9061 1.61036 11.585 1.61036 12.0033 2.0287L12.9773 3.00291C13.0804 3.10744 13.1577 3.22825 13.2092 3.3572C13.1577 3.22823 13.0804 3.1074 12.9773 3.00287L12.0033 2.02865C11.585 1.61032 10.9061 1.61032 10.4879 2.02865L10.104 2.41261L10.104 2.41264ZM3.36338 9.15189L3.36335 9.15186L9.59407 2.91977L12.0835 5.40974L12.0835 5.40976L9.59408 2.91982L3.36338 9.15189ZM3.64618 9.15191L5.85279 11.359L11.8007 5.40979L9.59408 3.20269L3.64618 9.15191ZM1.91958 13.0774L3.01101 9.8138L5.18527 11.9885L5.1853 11.9885L3.01099 9.81375L1.91954 13.0774L1.91958 13.0774ZM2.23626 12.761L3.09814 10.1838L4.81512 11.9012L2.23626 12.761Z" fill="#47AAB1"/>
              </svg>

             MODIFY
          </Button>
        </OverlayTrigger>

        {this.props.mode === 'internal' && this.props.classSubtype ?
          <React.Fragment>
            <h4 className="resultsHeading">ATTRIBUTE</h4>
            <span className="subheading">Class Subtype: {this.props.classSubtype}</span>
          </React.Fragment>
        : null}
        {this.props.mode === 'internal' && this.props.statusType !== '' && this.props.statusType !== 'Any' ?
          <span className="subheading"><br/>Status Type: {this.props.statusType}</span>
        : null}
        {this.props.mode === 'internal' && this.props.reserve !== 'any' ?
          <span className="subheading"><br/>Reserve: {this.props.reserve}</span>
        : null}
        {this.props.mode === 'internal' && this.props.fer !== 'any' ?
          <span className="subheading"><br/>Functional Economic Region Driver: {ferDriver}</span>
        : null}
        {this.props.areaMin > 0 ?
          <span className="subheading"><br/>Minimum area: {this.props.areaMin.toLocaleString()} sqm</span>
        : null}
        {this.props.areaMax > 0 ?
          <span className="subheading"><br/>Maximum area: {this.props.areaMax.toLocaleString()} sqm</span>
        : null}

        {this.props.nearbyTypeAlias ?
          <React.Fragment>
            <h4 className="resultsHeading mt-4">PROXIMITY</h4>
            <span className="subheading">Within {this.props.nearbyDistance}km of: {Pluralize.plural(this.props.nearbyTypeAlias)}</span>
          </React.Fragment>
        : null}

        <Form.Row className="mt-2" style={{height: 40 + 'px'}}>
          <Col xs={6}>
            {this.props.addRemoveChanged ? 
              <p id="txtAddRemoveAltered" className='mt-1'><em>Selection has been edited.</em></p>
            : null}
          </Col>

          <Col xs={6} className="text-right pr-0">
            {!extentChanged ? (
              <Button
                  disabled={searchPending}
                  onClick={() => this.props.toggleState('autoRunSearch')}
                  variant=""
                  className="pr-1"
                >
                  { this.props.autoRunSearch ? 
                    <img className="mr-1 resultsIcon"
                      src="./img/tickbox.svg"
                      alt="tick"
                    />
                  : 
                    <img className="mr-1 resultsIcon"
                      src="./img/tickbox_empty.svg"
                      alt="untick"
                    />
                  }
                  <span className="resultsText">Filter as map moves</span>
                </Button>

            ) : (
                <Button
                  type="submit"
                  value="Submit"
                  disabled={searchPending}
                  variant=""
                  className="pr-1"
                >
                  <FontAwesomeIcon
                    icon={faRedo}
                    className="mr-2"
                  />

                  <span className="resultsText">Filter in this map view</span>

                </Button>
            )}
          </Col>

        
        </Form.Row>
        <hr className='mt-2'/>

        <Form.Row className='ml-1 selectwrapper'>
          <h2>Selection</h2>

          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id='tooltip-right'>
                Remove all Crown Estate areas from the selection
              </Tooltip>
            }
          >
            <Button
                id="btnRemoveAll"
                className="pl-0 pr-0 resultsButton"
                variant="turquoiseText"
                onClick={() => this.props.removeAllSearchResults()}
                disabled={searchPending}
              >
                <svg className="mr-1 resultsIcon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.66667 0C2.98667 0 0 2.98667 0 6.66667C0 10.3467 2.98667 13.3333 6.66667 13.3333C10.3467 13.3333 13.3333 10.3467 13.3333 6.66667C13.3333 2.98667 10.3467 0 6.66667 0ZM6.66667 12C3.72667 12 1.33333 9.60667 1.33333 6.66667C1.33333 3.72667 3.72667 1.33333 6.66667 1.33333C9.60667 1.33333 12 3.72667 12 6.66667C12 9.60667 9.60667 12 6.66667 12Z" fill="#47AAB1"/>
                  <g clip-path="url(#clip0)">
                  <path d="M7.21603 6.66672L9.5522 4.33055C9.70357 4.17918 9.70357 3.93298 9.5522 3.78161C9.40083 3.63024 9.15463 3.63024 9.00326 3.78161L6.66709 6.11778L4.33092 3.77979C4.17955 3.62842 3.93335 3.62842 3.78198 3.77979C3.63062 3.93115 3.63062 4.17735 3.78198 4.32872L6.11816 6.66489L3.78198 9.00289C3.63062 9.15425 3.63062 9.40045 3.78198 9.55182C3.85858 9.62842 3.95706 9.66489 4.05736 9.66489C4.15767 9.66489 4.25615 9.6266 4.33274 9.55182L6.66892 7.21565L9.00509 9.55182C9.08168 9.62842 9.18016 9.66489 9.28047 9.66489C9.38077 9.66489 9.47925 9.6266 9.55585 9.55182C9.70722 9.40045 9.70722 9.15425 9.55585 9.00289L7.21603 6.66672Z" fill="#47AAB1"/>
                  </g>
                  <defs>
                  <clipPath id="clip0">
                  <rect width="6" height="6" fill="white" transform="translate(3.66669 3.66675)"/>
                  </clipPath>
                  </defs>
                </svg>
                REMOVE ALL
              </Button>
            </OverlayTrigger>


        </Form.Row>
        <Form.Row className='ml-1'>
          <p>Use map to modify selection:</p>
        </Form.Row>
        
        <Form.Row className='ml-1'>    
          <ButtonGroup className="mb-3">
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id='tooltip-right'>
                  Individually add Crown Estate areas to the selection using the map
                </Tooltip>
              }
            >
              <Button
                variant="outline"
                className={this.props.addRemoveMode === 'add' ? 'active' : null}
                onClick={this.props.toggleAddRemoveMode}
                data-mode="add"
              >
              <svg className = "mt-n1 mr-2" width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.1081 4.68006C11.4874 2.09667 7.26369 2.12701 4.6803 4.74779C2.0969 7.36857 2.12725 11.5922 4.74803 14.1756C7.36881 16.759 11.5925 16.7287 14.1759 14.1079C16.7593 11.4871 16.7289 7.26345 14.1081 4.68006ZM5.68404 13.2261C3.59027 11.1622 3.56595 7.77758 5.62985 5.6838C7.69376 3.59003 11.0784 3.56571 13.1721 5.62961C15.2659 7.69352 15.2902 11.0781 13.2263 13.1719C11.1624 15.2657 7.77782 15.29 5.68404 13.2261Z" fill="#47AAB1"/>
                <g clip-path="url(#clip0_803_270)">
                <path d="M9.81954 9.81329L13.1233 9.78956C13.3374 9.78802 13.5102 9.61268 13.5087 9.39862C13.5071 9.18456 13.3318 9.01172 13.1177 9.01326L9.81396 9.037L9.7915 5.73194C9.78996 5.51788 9.61463 5.34504 9.40057 5.34658C9.18651 5.34812 9.01367 5.52346 9.01521 5.73752L9.03895 9.04128L5.73391 9.06631C5.51985 9.06785 5.34701 9.24318 5.34855 9.45724C5.34933 9.56556 5.39386 9.66067 5.46529 9.73109C5.53672 9.8015 5.63374 9.84336 5.74078 9.84388L9.04454 9.82015L9.06828 13.1239C9.06906 13.2322 9.11359 13.3273 9.18502 13.3978C9.25645 13.4682 9.35347 13.51 9.46051 13.5105C9.67457 13.509 9.84741 13.3337 9.84587 13.1196L9.81954 9.81329Z" fill="#47AAB1"/>
                </g>
                <defs>
                <clipPath id="clip0_803_270">
                <rect width="6" height="6" fill="white" transform="translate(9.39746 5.1853) rotate(44.5884)"/>
                </clipPath>
                </defs>
              </svg>
                ADD
              </Button>
            </OverlayTrigger>
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id='tooltip-right'>
                  Individually remove Crown Estate areas from the selection using the map
                </Tooltip>
              }
            >
              <Button
                variant="outline"
                className={this.props.addRemoveMode === 'remove' ? 'active' : null}
                onClick={this.props.toggleAddRemoveMode}
                data-mode="remove"
              >
              <svg className = "mt-n1 mr-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.66667 0C2.98667 0 0 2.98667 0 6.66667C0 10.3467 2.98667 13.3333 6.66667 13.3333C10.3467 13.3333 13.3333 10.3467 13.3333 6.66667C13.3333 2.98667 10.3467 0 6.66667 0ZM6.66667 12C3.72667 12 1.33333 9.60667 1.33333 6.66667C1.33333 3.72667 3.72667 1.33333 6.66667 1.33333C9.60667 1.33333 12 3.72667 12 6.66667C12 9.60667 9.60667 12 6.66667 12Z" fill="#47AAB1"/>
              <g clip-path="url(#clip0_803_260)">
              <path d="M7.21652 6.66672L9.55269 4.33055C9.70406 4.17918 9.70406 3.93298 9.55269 3.78161C9.40132 3.63024 9.15512 3.63024 9.00375 3.78161L6.66758 6.11778L4.33141 3.77979C4.18004 3.62842 3.93384 3.62842 3.78247 3.77979C3.6311 3.93115 3.6311 4.17735 3.78247 4.32872L6.11864 6.66489L3.78247 9.00289C3.6311 9.15425 3.6311 9.40045 3.78247 9.55182C3.85907 9.62842 3.95755 9.66489 4.05785 9.66489C4.15816 9.66489 4.25664 9.6266 4.33323 9.55182L6.6694 7.21565L9.00558 9.55182C9.08217 9.62842 9.18065 9.66489 9.28096 9.66489C9.38126 9.66489 9.47974 9.6266 9.55634 9.55182C9.7077 9.40045 9.7077 9.15425 9.55634 9.00289L7.21652 6.66672Z" fill="#47AAB1"/>
              </g>
              <defs>
              <clipPath id="clip0_803_260">
              <rect width="6" height="6" fill="white" transform="translate(3.66699 3.66675)"/>
              </clipPath>
              </defs>
              </svg>
                REMOVE
              </Button>
            </OverlayTrigger>

          </ButtonGroup>
        </Form.Row>     

        <Form.Row>
          {!this.props.exceededTransferLimit ?  <p className="resultsSummary ml-2">{this.props.features.length.toLocaleString()} {areaMessage}</p> : null}
        </Form.Row>   

        {searchPending ? (
          <React.Fragment>
            <hr/>
            <div id="loading" className="d-flex justify-content-center">
              <img className="mt-2" height="30px" alt="loading" src={process.env.PUBLIC_URL + '/loading.gif'} />
            </div>
            <ul id="searchMessages">
              {searchMessages}
            </ul>
            {progress ? (
              <ProgressBar now={progress}/>
            ) : null}
            </React.Fragment>
        ) : (
          <div id="searchCards">
            {this.props.exceededTransferLimit ? (
              <p className="txtWarning text-center">Note: The number of areas identified exceeds 50,000. Please refine the search criteria.</p>
            ): <div>

                {features.map((feature, id) =>
                  <SearchResult
                    addRemoveChanged = {this.props.addRemoveChanged}
                    key={id}
                    areaMax = {this.props.areaMax}
                    areaMin = {this.props.areaMin}
                    classSubtype = {this.props.classSubtype}
                    feature={feature}
                    fer={this.props.fer}
                    geocodeForReport={this.props.geocodeForReport}
                    map={this.props.map}
                    mode={this.props.mode}
                    nearbyDistance = {this.props.nearbyDistance}
                    nearbyLayer = {this.props.nearbyLayer}
                    nearbyType = {this.props.nearbyType}
                    nearbyTypeAlias={this.props.nearbyTypeAlias}
                    removeFromSearchResults = {this.props.removeFromSearchResults}
                    reserve={this.props.reserve}
                    statusType = {this.props.statusType}
                    view={this.props.view}
                  />
                )}

            </div>}

            {showPagination ? (
              <div className="mt-3 pl-3">
                <Container>
                  <Row id="paginationRow">
                    <Col md={4}>
                      {offset + 1} to {Math.min(endIdx, this.props.features.length)} of {this.props.features.length}
                    </Col>
                    <Col md={3} className="offset-md-5">
                      <Button className="btnPagination" data-pagination="prev" onClick={this.props.updatePagination} disabled={offset===0}>
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9.00033 17.6663L10.5278 16.1388L4.48283 10.083H17.667V7.91634L4.48283 7.91634L10.5387 1.87134L9.00033 0.333008L0.33366 8.99967L9.00033 17.6663Z" fill="#C4C4C4"/>
                        </svg>
                      </Button>
                      <Button className="btnPagination" data-pagination="next" onClick={this.props.updatePagination} disabled={endIdx >= this.props.features.length}>
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.66667 -0.000322342L7.13917 1.52718L13.1842 7.58301H0L0 9.74968H13.1842L7.12833 15.7947L8.66667 17.333L17.3333 8.66634L8.66667 -0.000322342Z" fill="#C4C4C4"/>
                        </svg>
                      
                      </Button>
                    </Col>
                  </Row>
                </Container>
              </div>
            ) : null}

            {this.props.features.length > 0 ? 
              <Row className="mt-5 p-3 btnOpenReport">
                <Button
                  id="btnOpenReport"
                  className="btn btn-block clcButton mt-3"
                  variant="turquoiseText"
                  disabled={this.props.searchPending}
                  onClick={() => redirectToTarget('report', this.props)}
                >
                  CREATE REPORT
                </Button>
              </Row>
            : null}

          </div>
        )}

      </Form>
    );
  }
}

export { SearchResults };




